import React from 'react'
import styled from 'styled-components'
import { buildMenu } from './utils'
import { size } from './platform'
import type { MenuListElement } from './menuList'

type Props = {
  children: MenuListElement[]
  level: number
  key: string
  className?: string
}

export const SubMenu = styled(({ children, level, key, className }: Props) => (
  <>
    <input id={`sm${key}`} type="checkbox" />
    <ul className={className}>{buildMenu(children, level + 1)}</ul>
  </>
))`
  width: fit-content;
  border: 1px solid rgb(222, 222, 222);
  border-radius: 8px;
  background-color: white;
  margin: 0;
  padding: 8px 1px;
  position: absolute;
  z-index: 3000;
  flex-direction: column;
  display: none;
  margin-top: 32px;

  @media only screen and (max-width: ${size.md}) {
    flex-direction: column;
    width: 100%;
    border: 0;
    margin: 0;
    height: fit-content;
    position: relative;
    float: none;
  }
`
